import React from 'react';

export const CanvasXIcon = () => {
  return <span style={{ fontWeight: '650' }}>X</span>;
};
